import React from 'react';
import { styled } from '@mui/material';

import { Autocomplete, Box, Button, Form, IconButton, Stack, Text, TextInput } from 'shell/components';
import { MAJOR_LIST, SEMESTER_LIST, US_SCHOOL_LIST, CA_SCHOOL_LIST } from 'utils/constants';

const LIST_OF_SCHOOLS = [
    ...(window.location.origin === 'https://app.ensightful.ca' ? CA_SCHOOL_LIST : US_SCHOOL_LIST),
    { name: 'Other' },
];

const GeneralInformation = ({ errors, form, handleChange, handleNext, handleClose, PAGES, isLti = false }) => {
    return (
        <GeneralInformationBox>
            <Stack spacing={1} sx={{ mt: 6 }}>
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                    <Text variant={'p1'} color={'primary'}>
                        STEP 1 of 2
                    </Text>
                    {!isLti && (
                        <IconButton
                            aria-label={'close'}
                            kind={'exit'}
                            size={'medium'}
                            variant={'square'}
                            onClick={handleClose}
                        />
                    )}
                </Stack>
                <Text variant={'h6'} weight={'medium'}>
                    General Information
                </Text>
                <Text variant={'p1'} sx={{ textAlign: 'left' }}>
                    To set up your new course, please input all the details of the class in the space below.
                </Text>
            </Stack>
            <Form onSubmit={() => handleNext(PAGES.PROJECT_SETTING)}>
                <InputStack spacing={6}>
                    <Autocomplete
                        data-cy={'institution-name-dropdown'}
                        disableClearable
                        value={form.institutionName}
                        label={'Institution Name'}
                        error={Boolean(errors.institutionName)}
                        helperText={errors.institutionName}
                        placeholder={'Select'}
                        required
                        options={LIST_OF_SCHOOLS?.map((item) => {
                            return {
                                key: item.name,
                                value: item.name,
                            };
                        })}
                        virtualized
                        onChange={(_, selectedItem) => handleChange('institutionName', selectedItem)}
                    />
                    {form.institutionName?.value === 'Other' && (
                        <TextInput
                            error={Boolean(errors.otherInstitutionName)}
                            helperText={errors.otherInstitutionName}
                            label={'Please Specify:'}
                            onChange={(e) => handleChange('otherInstitutionName', e.target.value)}
                            placeholder={'Enter institution name'}
                            value={form.otherInstitutionName}
                            required
                        />
                    )}
                    <TextInput
                        error={Boolean(errors.faculty)}
                        helperText={errors.faculty}
                        label={'Faculty'}
                        onChange={(e) => handleChange('faculty', e.target.value)}
                        placeholder={'Enter faculty'}
                        value={form.faculty}
                        required
                    />
                    <Autocomplete
                        disableClearable
                        error={Boolean(errors.fieldOfStudy)}
                        helperText={errors.fieldOfStudy}
                        placeholder={'Select'}
                        required={true}
                        value={form.fieldOfStudy}
                        label={'Field of Study'}
                        labelId={'field-of-study-select'}
                        options={MAJOR_LIST?.map((item) => {
                            return {
                                key: item.name,
                                value: item.name,
                            };
                        })}
                        onChange={(e, selectedItem) => handleChange('fieldOfStudy', selectedItem)}
                    />
                    <TextInput
                        error={Boolean(errors.courseName)}
                        helperText={errors.courseName}
                        label={'Course name'}
                        onChange={(e) => handleChange('courseName', e.target.value)}
                        placeholder={'Enter course name'}
                        value={form.courseName}
                        required
                    />
                    <TextInput
                        error={Boolean(errors.section)}
                        helperText={errors.section}
                        label={'Section'}
                        onChange={(e) => handleChange('section', e.target.value)}
                        placeholder={'Enter section'}
                        value={form.section}
                        required
                    />
                    <Autocomplete
                        disableClearable
                        error={Boolean(errors.semester)}
                        helperText={errors.semester}
                        placeholder={'Select'}
                        required={true}
                        value={form.semester}
                        label={'Semester'}
                        options={SEMESTER_LIST?.map((item) => {
                            return {
                                key: item.value,
                                value: item.title,
                            };
                        })}
                        onChange={(_, selectedItem) => handleChange('semester', selectedItem)}
                    />
                </InputStack>

                <Stack sx={{ margin: (theme) => theme.spacing(6, 0, 2, 0) }} alignItems={'flex-end'}>
                    <Button data-cy={'general-information-next-button'} type={'submit'}>
                        Next
                    </Button>
                </Stack>
            </Form>
        </GeneralInformationBox>
    );
};

const GeneralInformationBox = styled(Box)(({ theme }) => {
    return {
        width: '100%',
        height: '100%',
        background: theme.palette.ensightful.shades[0],
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
    };
});

export default GeneralInformation;
